import {UI} from "../../../../../../stem-core/src/ui/UIBase.js";

import {BasePanelPage} from "../../../../PanelPage.jsx";
import {Messages} from "../../../../../Messages.js";
import {MessageElement} from "../../../../../widget/ui/MessageElement.jsx";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService.js";
import {Router} from "../../../../../../stem-core/src/ui/Router.jsx";
import {INLINE_USER_DASHBOARD_URLS} from "../../../../PanelConstants.js";
import {BlinkButton} from "../../../../../../core/ui/Button.jsx";


export class EditSubscriptionSuccessPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.subscribeChangeSuccess,
        }
    }

    render() {
        return [
            <MessageElement message={Messages.subscribeAndEditSuccess(iFrameMerchantService.getMerchant().getName())}/>,
            <BlinkButton
                label={Messages.ok}
                className={this.styleSheet.actionButton}
                onClick={() => {
                    // TODO @flow2 we should probably just pop from the situation
                    Router.changeURL(INLINE_USER_DASHBOARD_URLS.home);
                }}/>,
        ];
    }
}
